import React from 'react';
import { Container } from 'reactstrap';

import { useSelector } from 'react-redux';
import {
  isAdmin as isAdminSelector,
  isManager as isManagerSelector,
  isEditor as isEditorSelector,
  isTranslator as isTranslatorSelector,
} from '../../selectors/auth';

import AdminDashboard from './admin';
import TranslatorDashboard from './translator';

const Dashboard = (props) => {
  const isAdmin = useSelector(isAdminSelector);
  const isManager = useSelector(isManagerSelector);
  const isEditor = useSelector(isEditorSelector);
  const isTranslator = useSelector(isTranslatorSelector);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <>{(isAdmin || isManager || isEditor) && <AdminDashboard />}</>
          <>{isTranslator && <TranslatorDashboard />}</>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
